import { captureMessage } from "@sentry/react";
import { getUserStateMutationErrorMeta } from "./get-user-state-mutation-error-meta";

function serializeErrorExtra(error: unknown): Record<string, unknown> {
  if (error && typeof error === "object") {
    try {
      return JSON.parse(JSON.stringify(error)) as Record<string, unknown>;
    } catch {
      return { raw: String(error) };
    }
  }
  return { raw: String(error) };
}

/**
 * Reports failed saved-job PUT/DELETE to Sentry with tags (skips expected 409 races).
 * Call from client-only code paths.
 */
export function captureSavedJobUserStateSyncFailure(params: {
  operation: "persist" | "delete_remote";
  itemKey: string;
  jobId: string;
  clientVersion: number;
  error: unknown;
}): void {
  if (typeof window === "undefined") {
    return;
  }

  const meta = getUserStateMutationErrorMeta(params.error);
  if (meta.isVersionConflict) {
    return;
  }

  try {
    captureMessage(`User state saved-job sync failed (${params.operation})`, {
      level: "error",
      tags: {
        user_state_area: "saved_job",
        user_state_operation: params.operation,
        ...(meta.httpStatus != null ? { http_status: String(meta.httpStatus) } : {}),
      },
      extra: {
        itemKey: params.itemKey,
        jobId: params.jobId,
        clientVersion: params.clientVersion,
        error: serializeErrorExtra(params.error),
      },
    });
  } catch {
    // Sentry optional / not yet loaded
  }
}
